import { SpeechRecognitionAdapter } from '@app/core/models';

export class SpeechRecognitionWebAdapter implements SpeechRecognitionAdapter {
  private recognition: any;

  constructor() {
    if (!('webkitSpeechRecognition' in window)) return;

    // @ts-ignore
    this.recognition = new webkitSpeechRecognition();
    this.recognition.continuous = false;
    this.recognition.interimResults = false;
    this.recognition.lang = navigator.language ?? 'it-IT';
  }

  start(onResult: (t: string) => void) {
    if (!this.recognition) return;

    this.recognition.onresult = (e: any) => {
      onResult(e.results[0][0].transcript);
      this.recognition.stop();
    };
    this.recognition.onerror = () => this.recognition.stop();

    this.recognition.start();
  }

  stop() {
    this.recognition?.stop?.();
  }
}
